import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import ProductPricing from '../entities/product-pricings/product-pricing';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import appconst from './../../lib/appconst';
interface ProductPricingState extends ListState<ProductPricing> {}
class ProductPricingModule extends ListModule<ProductPricingState, any, ProductPricing> {
	state = {
		totalCount: 0,
		currentPage: 1,
		pageSize: 10,
		list: new Array<ProductPricing>(),
		loading: false,
	};
	actions = {
		async getAll(context: ActionContext<ProductPricingState, any>, payload: any) {
			context.state.loading = true;
			const {
				data: { result },
			} = await Ajax.get('/api/services/app/ProductPricing/GetAll', { params: payload.data });
			context.state.loading = false;
			const page = result as PageResult<ProductPricing>;
			context.state.totalCount = page.totalCount;
			context.state.list = page.items;
		},
		async get(context: ActionContext<ProductPricingState, any>, payload: any) {
			let reponse = await Ajax.get('/api/services/app/ProductPricing/GetDetail?Id=' + payload.data.id);
			return reponse.data.result as ProductPricing;
		},
		async create(context: ActionContext<ProductPricingState, any>, payload: any) {
			await Ajax.post('/api/services/app/ProductPricing/Create', payload.data);
		},
		async update(context: ActionContext<ProductPricingState, any>, payload: any) {
			await Ajax.put('/api/services/app/ProductPricing/Update', payload.data);
		},
		async delete(context: ActionContext<ProductPricingState, any>, payload: any) {
			await Ajax.delete('/api/services/app/ProductPricing/Delete?Id=' + payload.data.id);
		},
		async getClientPricingProfiles(context: ActionContext<ProductPricingState, any>, payload: any) {
			let reponse = await Ajax.get('/api/services/app/ProductPricing/GetClientPricingProfiles', {
				params: payload.data,
			});
			return reponse.data.result.items;
		},
		async getPricingTerms(context: ActionContext<ProductPricingState, any>, payload: any) {
			let reponse = await Ajax.get('/api/services/app/ProductPricing/GetPricingTerms', { params: payload.data });
			return reponse.data.result.items;
		},
		async exportProductProductPricings(context: ActionContext<ProductPricingState, any>, payload: any) {
			var url = `${appconst.remoteServiceBaseUrl}export/ExportProductPricings${abp.utils.buildQueryString(
				Object.keys(payload.data).map(key => {
					return {
						name: key,
						value: payload.data[key],
					};
				}),
				true
			)}`;
			window.open(url, '_blank');
		},
	};
	mutations = {
		setCurrentPage(state: ProductPricingState, page: number) {
			state.currentPage = page;
		},
		setPageSize(state: ProductPricingState, pagesize: number) {
			state.pageSize = pagesize;
		},
	};
}
const productPricingModule = new ProductPricingModule();
export default productPricingModule;
